module.exports = __webpack_public_path__ + "static/media/TrueNorthLaptop_small.6b168d27.png";